<template>
  <AppContainer justify-center>
    <EHeroContent
      icon="paper-plane"
      variant="success"
      :title="t(useTranslationPath(callerPath, 'title'))"
      :description="
        t(useTranslationPath(callerPath, 'description'), {
          identifier: unauthenticatedTokenStore.sentTo,
        })
      "
    />
  </AppContainer>
</template>

<script setup>
import { EHeroContent } from '@expansivefm/eds'

import AppContainer from '@/components/AppContainer.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const unauthenticatedTokenStore = useUnauthenticatedTokenStore()
const appStore = useAppStore()
const callerPath = 'views.unauthenticated.verification.sent'

onMounted(async () => {
  appStore.showBackButton = false
})
</script>
